// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@media (-ms-high-contrast:active),(-ms-high-contrast:none){.v-list-item__title[data-v-25d9fca6]{white-space:nowrap!important}}.disableCursor[data-v-25d9fca6]{pointer-events:none!important}.enableCursor[data-v-25d9fca6]{pointer-events:all!important}.newsArticleSubtitle[data-v-25d9fca6]{display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;white-space:pre-line}.expanded.newsArticleSubtitle[data-v-25d9fca6]{-webkit-line-clamp:unset}", ""]);
// Exports
module.exports = exports;
